<template>
  <div
    class="
      flex flex-col lg:flex-row items-start justify-center
      max-w-5xl gap-4 lg:gap-8 p-10 lg:px-32 lg:py-16 bg-EXPONDO-grey-5
    "
  >
    <div class="flex-shrink-0 rounded-md p-3 bg-EXPONDO-grey">
      <span class="iconify svg--search-error text-EXPONDO-white text-5xl " />
    </div>
    <div v-if="searchTerm">
      <h2 class="mb-1">
        {{ $t('We’re Sorry') }}
      </h2>
      <i18n-t
      keypath="we-couldnt-find-X"
      tag="p"
      class="mb-3">
        <template #search_term>
          <strong>{{ searchTerm }}</strong>
        </template>
      </i18n-t>
      <ul class="mb-4 pl-4">
        <li>
          {{ $t('Check your spelling') }}
        </li>
        <li>
          {{ $t('Try more general words') }}
        </li>
        <li>
          {{ $t('Try different words that mean the same thing') }}
        </li>
      </ul>
      <i18n-t
      keypath="or-try-searching"
      tag="p">
        <template #or>
          <strong class="uppercase">{{ $t('or-uppercase') }}</strong>
        </template>
      </i18n-t>
    </div>
    <div v-else>
      <h2 class="mb-4 lg:mb-1">
        {{ $t('This is embarrassing.') }}
      </h2>
      <p>
        {{ $t('we-cant-seem-to-find') }}
      </p>
      <p class="mb-5">
        {{ $t('we-recommend-searching') }}
      </p>
      <i18n-t
      keypath="or-try-searching"
      tag="p">
        <template #or>
          <strong class="uppercase">{{ $t('or-uppercase') }}</strong>
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'NoResults',
  props: {
    searchTerm: {
      type: String,
      default: '',
    },
  },
});

</script>
